import { ThemeProvider, createTheme } from '@mui/material'
import Landing from './landing/Landing'
import React from 'react'
import { RecoilRoot } from 'recoil'

const theme = createTheme({
  palette: {
    primary: {
      main: '#3B62AE',
    },
    secondary: {
      main: '#b5d443',
    },
  },
})

function App() {
  return (
    <ThemeProvider theme={theme}>
      <RecoilRoot>
        <Landing />
      </RecoilRoot>
    </ThemeProvider>
  )
}

export default App
